var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdicionarCasaProdutoImobiliario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_838_15274",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 53
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 53,
    height: 53,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_838_15274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5516 14.9487H41.949V11.5513H38.5516V14.9487ZM40.2503 44.1666C37.79 44.1666 35.7027 43.3095 33.9884 41.5952C32.2741 39.8809 31.417 37.7936 31.417 35.3333C31.417 32.873 32.2741 30.7857 33.9884 29.0714C35.7027 27.3571 37.79 26.5 40.2503 26.5C42.7106 26.5 44.7979 27.3571 46.5122 29.0714C48.2265 30.7857 49.0837 32.873 49.0837 35.3333C49.0837 37.7936 48.2265 39.8809 46.5122 41.5952C44.7979 43.3095 42.7106 44.1666 40.2503 44.1666ZM39.4009 41.7035H41.0997V36.1827H46.6205V34.4839H41.0997V28.9631H39.4009V34.4839H33.8801V36.1827H39.4009V41.7035ZM49.0837 23.3361C47.8464 22.3565 46.462 21.6197 44.9303 21.1256C43.3986 20.6316 41.8386 20.3846 40.2503 20.3846C39.4774 20.3846 38.725 20.4433 37.9931 20.5608C37.2613 20.6783 36.5415 20.8588 35.8337 21.1023V18.7708L23.433 9.8695V4.41663H49.0837V23.3361ZM4.91699 39.75V20.9791L18.167 11.5512L31.417 20.9791V23.3616C29.5031 24.6979 28.0054 26.4398 26.9239 28.5873C25.8424 30.7347 25.3016 32.9834 25.3016 35.3333C25.3016 36.1629 25.3575 36.9124 25.4693 37.582C25.5812 38.2515 25.7674 38.9742 26.0278 39.75H22.2439V28.5384H14.0901V39.75H4.91699Z",
    fill: "#8675FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdicionarCasaProdutoImobiliario);
export default __webpack_public_path__ + "static/media/adicionar-casa-produto-imobiliario.aac90c9a7c58af7732254f0eba7ccb94.svg";
export { ForwardRef as ReactComponent };